import XTableNamer from "./XTableNamer.js";
import * as Excel from "exceljs/dist/exceljs.min.js";

import {
  saveAs
} from 'file-saver'

/**
 * Exceldownload working with NSWOW2 Tables
 */
class XDownloader {
  constructor(config = {}) {
    const {
      tableTitle,
      tableSelector,
      excludeTableSelector,
      downloadText, // Text for downloadbutton, can be empty if you want to use an icon
      styles, // cell Styles from classes
      numFmt, // numFmt overwrite for custom formatting
      mergeStrings, // Set mergeStrings for all Tables
      tableCellFormatter,
    } = config;

    const env = this.getEnvironement();

    this.excludeTableSelector = excludeTableSelector || null;
    this.tableSelector = tableSelector || '.ns-table-wrap';
    this.downloadText = downloadText || 'XLS'; //Text on button, can be empty
    this.tableTitle = tableTitle || null;
    this.styles = styles.map(item => { if (!item.index) item.index = 0; return item; }) || {};
    this.numFmt = numFmt || function (cell) { }
    this.mergeStrings = mergeStrings || [];
    this.tableCellFormatter = tableCellFormatter || this.htmlTableCellFormatter;

    const tables = Array.prototype.slice.call(document.querySelectorAll(this.tableSelector)).filter(table => {
      if (!this.excludeTableSelector) return true;

      const finding = table.querySelector(this.excludeTableSelector);

      if (!!finding) return false;

      return true;
    });

    new XTableNamer();

    tables.forEach(table => {
      if (this.checkTable(table)) {
        this.addLink(table);
      } else if (env === 'stage') {
        this.addLink(table, true);
      }
    });
  }

  checkTable(table) {
    /*const TDs = Array.prototype.slice.call( table.querySelectorAll('tr:first-child > td') );
    let rt = true;
    TDs.forEach( td => {
      if(td.colSpan > 1) rt = false;
    } );*/
    return true;
  }

  createWorkbook(table) {
    this.mergeStrings = [];

    this.name = table.querySelector('[data-tableid]').dataset.tableid
    const workbook = new Excel.Workbook();
    this.worksheet = workbook.addWorksheet(this.name);
    this.fileName = this.getFileTitle(table);
    try {
      this.parseTable(table);
      this.parseFootnote(table);
      this.mergeCells(table);
      this.saveFile(this.fileName, workbook);
    } catch (err) {
      alert(`Die Tabelle hat verbundene Zellen in der ersten Reihe, das wird nicht unterstützt vom XDownloader.
      Falls verbundene Zellen in der ersten Reihe benötigt werden bitte erste Zeile leer mit der Klasse .excel-download erfassen`);
      console.error(err)
    }
  }

  mergeCells(table) {
    this.mergeStrings = this.mergeStrings.filter((value, index) => {
      return this.mergeStrings.indexOf(value) === index;
    })
    this.mergeStrings.forEach(s => {
      try {
        this.worksheet.mergeCells(s);
      } catch (error) {
        console.error(error);
      }
    });
  }

  /**
   * This one parses the footnotes and puts it after the table content in the worksheet
   * @param {*} table
   */
  parseFootnote(table) {
    let footnotes = Array.prototype.slice.call(table.querySelectorAll('p.ns-footnote'));

    if (footnotes.length <= 0) {
      let nextSibling = table.nextElementSibling;
      while (nextSibling && nextSibling.classList.contains('ns-footnote')) {
        footnotes.push(nextSibling);
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    if (footnotes.length > 0) {
      this.worksheet.addRow([]);
      footnotes.forEach(fn => {
        this.worksheet.addRow([fn.innerText.replace('\n', ' ')]);
      });
    }
  }

  getFileTitle(elem) {
    let name = elem.closest(this.tableSelector).dataset.xFileTitle;
    if (name) name = name.replaceAll(/\./g, '');
    return name;
  }

  getTitle(elem) {
    return elem.closest(this.tableSelector).dataset.xTitle;
  }

  htmlTableCellFormatter(td) {
    let cell = document.createElement('td');
    cell.innerHTML = td.innerHTML;
    let superscript = cell.querySelector('.superscript');
    let superscriptContent = '';
    if (superscript) {
      superscriptContent = '(' + superscript.innerText + ')';
      superscript.parentNode.removeChild(superscript);
    }

    if (td.querySelector('.note__link')) {
      return this.correctNote(cell.innerText.trim() + ' ' + superscriptContent);
    } else {
      return this.correct(cell.innerText.trim() + ' ' + superscriptContent);
    }
  }



 /**
   * This one parses the table and puts it into the worksheet
   * @param {*} table
   */
 parseTable(table) {
  const t = table.querySelector('table');
  const rows = Array.prototype.slice.call(t.querySelectorAll('tr'));
  let content = [];
  let styles = [];

  // Matrix to track merged cells
  let matrix = [];

  // Initialize matrix
  for (let i = 0; i < rows.length; i++) {
    matrix[i] = [];
  }

  // Get title and calculate row offset
  const title = this.getTitle(table);
  // Calculate offset: 1 for initial empty row, 2 for title and spacing if title exists
  const rowOffset = 1 + (title ? 2 : 0);

  // First pass: analyze rowspans and fill matrix
  let rowIndex = 0;
  rows.forEach(r => {
    let colIndex = 0;
    let tds = r.querySelectorAll('tr, td');

    tds.forEach(td => {
      // Skip columns that are already occupied by rowspans
      while (matrix[rowIndex] && matrix[rowIndex][colIndex]) {
        colIndex++;
      }

      // Ensure rowSpan and colSpan are valid numbers
      const rowSpan = td.hasAttribute('rowspan') ? parseInt(td.rowSpan) || 1 : 1;
      const colSpan = td.hasAttribute('colspan') ? parseInt(td.colSpan) || 1 : 1;

      // Fill matrix for this cell and its spans
      for (let i = 0; i < rowSpan; i++) {
        for (let j = 0; j < colSpan; j++) {
          if (matrix[rowIndex + i]) {
            matrix[rowIndex + i][colIndex + j] = {
              content: i === 0 && j === 0 ? td : null,
              isSpanned: i !== 0 || j !== 0,
              originalCell: td,
              isPartOfColspan: j > 0  // New flag to track colspan parts
            };
          }
        }
      }

      // Important: increment colIndex by actual colspan
      colIndex += colSpan;
    });
    rowIndex++;
  });


  // Second pass: create Excel rows using matrix
  let counterR = 0;

  this.setColumnWidthByHeader(rows, table);

  matrix.forEach((row, rowIndex) => {
    styles = [];
    content = [];
    counterR++;
    let counterC = 0;

    row.forEach((cell, colIndex) => {
      // Skip cells that are part of a colspan
      if (cell?.isPartOfColspan) {
        return;
      }

      counterC++;

      if (!cell || cell.isSpanned) {
        content.push('');
        return;
      }

      const td = cell.content;
      styles[counterC] = this.getStyles(td);
      let c = this.htmlTableCellFormatter(td);

      c = c == '\u00A0' || c.trim() == '' ? c : {
        'richText': [{
          'text': c.toString()
        }]
      };

      content.push(c);

      // Handle colspan and rowspan merges
      if (td.hasAttribute('colspan') || td.hasAttribute('rowspan')) {
        // Handle colspan
        if (td.hasAttribute('colspan')) {
          const colspan = parseInt(td.colSpan) || 1;
          if (colspan > 1) {
            // Add empty cells for colspan
            for (let i = 1; i < colspan; i++) {
              content.push('');
              counterC++;
            }

            // Add rowOffset to the row numbers
            const colMergeString = `${this.getLetter(counterC - colspan + 1)}${counterR + rowOffset}:${this.getLetter(counterC)}${counterR + rowOffset}`;
            this.mergeStrings.push(colMergeString);
          }
        }

        // Handle rowspan - only if we're not in a spanned cell
        if (td.hasAttribute('rowspan') && !cell.isSpanned) {
          const rowspan = parseInt(td.rowSpan) || 1;
          if (rowspan > 1) {
            // Verify that we actually have cells to span
            let canSpan = true;
            for (let i = 1; i < rowspan; i++) {
              if (!matrix[rowIndex + i] || matrix[rowIndex + i][colIndex]?.originalCell !== td) {
                canSpan = false;
                break;
              }
            }

            if (canSpan) {
              // Add rowOffset to the row numbers
              const rowMergeString = `${this.getLetter(counterC)}${counterR + rowOffset}:${this.getLetter(counterC)}${counterR + rowspan - 1 + rowOffset}`;
              this.mergeStrings.push(rowMergeString);
            }
          }
        }
      }
    });

    // Add row to worksheet
    this.worksheet.addRow(content);
    let wsRow = this.worksheet.lastRow;

    // Apply styles
    for (let i = 1; i < styles.length; i++) {
      if (styles[i]) {
        if (styles[i].alignment) wsRow.getCell(i).alignment = styles[i].alignment;
        if (styles[i].border) wsRow.getCell(i).border = styles[i].border;
        if (styles[i].font) wsRow.getCell(i).font = styles[i].font;
        if (styles[i].fill) wsRow.getCell(i).fill = styles[i].fill;
      }
      if (this.numFmt) {
        this.numFmt.call(this, wsRow.getCell(i), i, counterR);
      }
    }
  });
}

setColumnWidthByHeader(rows, tableElement) {
  const headerClasses = ['excel-download', 'head', ...this.styles.filter(item => item.head).map(item => item.class)];
  let isHeader = false;
  let first = true;
  let content = [];
  let headerRow = null;
  let exceldownload = rows.filter(row => row.classList.contains('excel-download'));

  // Add initial empty row with small height
  this.worksheet.addRow([]);
  let row = this.worksheet.lastRow;
  row.height = 0.5;

  const title = this.getTitle(tableElement);

  if(title) {
    this.worksheet.addRow([title]);
    row = this.worksheet.lastRow;
    row.getCell('A').font = { size: 16, bold: true };
    this.worksheet.addRow([]);
  }

  if (!!exceldownload[0]) {
    headerRow = exceldownload[0];
  } else {
    rows.forEach(r => {
      if (first) {
        headerClasses.forEach(item => {
          if (r.classList.contains(item)) {
            isHeader = true;
            headerRow = r;
          }
        });
      }
    });
  }


  if (headerRow) {
    first = false;

    const tds = Array.prototype.slice.call(headerRow.querySelectorAll('td'));

    tds.forEach(t => { //first iteration for header column without content to set widths of columns

      content.push({
        header: ' ',
        key: 'id',
        width: t.offsetWidth / 7
      });
    });
    this.worksheet.columns = content;

    content = [];

    let row = this.worksheet.lastRow;

    if (this.tableTitle) {
      let title = '';
      if (typeof this.tableTitle == 'string') {
        title = this.tableTitle + ' ' + this.fileName.replaceAll('_', ' ');
      } else if (typeof this.tableTitle == 'function') {
        title = this.tableTitle.call(this, tableElement) + ' ' + this.fileName.replaceAll('_', ' ');
      }

      this.worksheet.addRow([]);

      this.worksheet.addRow([title]);
      row = this.worksheet.lastRow;

      row.getCell('A').font = {
        size: 16,
        bold: true
      };

      this.worksheet.addRow([]);
    }
  }
  else {
    return;
  }
}

/**
 * check for classes and return the right styles
 * can be extended
 * @param {*} t
 */
getStyles(t) {
  let r = [];

  const styles = this.styles.filter((style) => {
    const classes = Array.isArray(style.class) ? style.class : [style.class];
    return classes.every(cls => t.classList.contains(cls));
  }).sort((a, b) => {
    // sort index of importance lowest first
    if (a.index < b.index) {
      return 1;
    }

    if (a.index > b.index) {
      return -1;
    }

    return 0;
  });

  if (t.classList.contains('ns-horizontal-left')) {
    r.alignment = { horizontal: 'left', wrapText: true }
  }
  if (t.classList.contains('ns-horizontal-right')) {
    r.alignment = { horizontal: 'right', wrapText: true }
  }
  if (t.classList.contains('ns-horizontal-center')) {
    r.alignment = { horizontal: 'center', wrapText: true }
  }
  if (t.classList.contains('vamiddle')) {
    r.alignment = { vertical: 'middle' }
  }

  // merge all styles, most important style is applied last
  if (styles.length > 0) {
    styles.forEach(style => {
      r = {
        ...r,
        ...style,
        class: undefined, // remove classes
        head: undefined,
        index: undefined
      };
    });
  }

  // if no border style set
  if (!'border' in r) {
    r.border = {};
  }

  // when no fill set, default to white to hide lines
  if (!!!r.fill || !!!r.fill.fgColor) {
    r.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {
        argb: 'FFFFFFFF'
      }
    };
  }

  r.colspan = t.colSpan;

  return r;
}


  /**
   * yeah well, add the fucking link to the table, this one doesnt need explanation
   * @param {*} table
   */
  addLink(table, error) {
    let link = document.createElement('a');
    link.classList.add('exceldl-link');

    if (error) {
      link.classList.add('error');
      console.log('error');
    }
    link.innerText = this.downloadText;
    link.href = '#';

    table.prepend(link);

    link.addEventListener('click', (e) => {
      e.preventDefault();
      this.createWorkbook(table);
    });
  }

  /**
   * savefile doesnt need explanation as well
   * @param {*} fileName
   * @param {*} workbook
   */
  async saveFile(fileName, workbook) {
    const xls64 = await workbook.xlsx.writeBuffer({
      base64: true
    })
    saveAs(
      new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      fileName
    )
  }

  /**
   * delete the thousand marks and replace false minus with right one
   */
  correct(text) {
    return text.replace(/'/g, '').replace(/(?:\r\n|\r|\n)/g, '\n').replace(/’/g, '').replace(/– /g, '-').replace(/–/g, '-').replace(/'/g, '.').replace(/–/g, '-').replace(/(\d)\.0+(?!\d)/g, '$1');
  }

  correctNote(text) {
    return text.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-');
  }

  getLetter(number){
    const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    return letters[number-1];
  }

  getEnvironement() {
    const body = document.querySelector('body');
    if (body.classList.contains('wp-production')) {
      return 'production';
    } else {
      return 'stage';
    }
  }

}
export default XDownloader;
